import { Layer } from '@graphql';

import type { LayerInfo } from './types';

type MetaContent = {
  title: string;
  description: string;
  boxTitle: string;
};

export function getMetaContent(layer: LayerInfo, streetName?: string | null): MetaContent {
  const date = new Date();
  /* eslint-disable @typescript-eslint/restrict-template-expressions */
  if (layer.layerType === Layer.DistrictSmall) {
    return {
      title: `Immobilienpreise ${layer.city} ${
        layer.districtSmall
      } ${date.getFullYear()} | McCompass`,
      description: `Aktuelle Immobilienpreise in ${layer.city} ${layer.districtSmall} >> Quadratmeterpreise für Wohnung & Haus ✔ Immobilienwert einfach abfragen ✔ | McCompass von McMakler`,
      boxTitle: `Immobilienpreise in ${streetName || layer.districtSmall} ${date.getFullYear()}`,
    };
  }

  if (layer.layerType === Layer.District) {
    if (layer.state === layer.city) {
      return {
        title: `Immobilienpreise ${layer.city} ${layer.district} ${date.getFullYear()} | McCompass`,
        description: `Aktuelle Immobilienpreise in ${layer.city} ${layer.district} >> Quadratmeterpreise für Wohnung & Haus ✔ Immobilienwert einfach abfragen ✔ | McCompass von McMakler`,
        boxTitle: `Immobilienpreise in ${streetName || layer.district} ${date.getFullYear()}`,
      };
    }
    return {
      title: `Immobilienpreise ${layer.city} ${layer.district} ${date.getFullYear()} | McCompass`,
      description: `Aktuelle Immobilienpreise in ${layer.city} ${layer.district} >> Quadratmeterpreise für Wohnung & Haus ✔ Immobilienwert einfach abfragen ✔ | McCompass von McMakler`,
      boxTitle: `Immobilienpreise in ${streetName || layer.district} ${date.getFullYear()}`,
    };
  }

  if (layer.layerType === Layer.City) {
    if (layer.state === layer.city) {
      return {
        title: `Immobilienpreise ${
          layer.city
        } ${date.getFullYear()} >> Preise abfragen | McCompass`,
        description: `Aktuelle Immobilienpreise in ${layer.city} >> Quadratmeterpreise für Wohnung & Haus ✔ Immobilienwert Ihrer Immobile einfach abfragen ✔ | McCompass von McMakler`,
        boxTitle: `Immobilienpreise in ${streetName || layer.city} ${date.getFullYear()}`,
      };
    }
    return {
      title: `Immobilienpreise ${layer.city} ${date.getFullYear()} >> Preise abfragen | McCompass`,
      description: `Aktuelle Immobilienpreise in ${layer.city} >> Quadratmeterpreise für Wohnung & Haus ✔ Immobilienwert Ihrer Immobile einfach abfragen ✔ | McCompass von McMakler`,
      boxTitle: `Immobilienpreise in ${streetName || layer.city}  ${date.getFullYear()}`,
    };
  }

  if (layer.layerType === Layer.State) {
    return {
      title: `Immobilienpreise ${layer.state} ${date.getFullYear()} >> Preise abfragen | McCompass`,
      description: `Aktuelle Immobilienpreise in ${layer.state} >> Quadratmeterpreise für Wohnung & Haus ✔ Immobilienwert Ihrer Immobile einfach abfragen ✔ | McCompass von McMakler`,
      boxTitle: `Immobilienpreise in ${streetName || layer.state} ${date.getFullYear()}`,
    };
  }
  /* eslint-enable @typescript-eslint/restrict-template-expressions */

  return {
    title: `Immobilienpreise ${date.getFullYear()} >> Preise abfragen | McCompass`,
    description:
      'Aktuelle Immobilienpreise >> Quadratmeterpreise für Wohnung & Haus  ✔ Immobilienwert Ihrer Immobile einfach abfragen ✔ | McCompass von McMakler',
    boxTitle: `Immobilienpreise ${date.getFullYear()}`,
  };
}
